module.exports = __webpack_public_path__ + "img/competitor.c1ff7f43.svg";